<template>
  <div class="public-content balance-payment">
    <div class="breadcrumb">余额支付审核</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <!-- <el-col :span="6">
            <el-form-item label="流水号:">
              <el-input v-model="formInline.serialNo" placeholder="请输入流水单号"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="订单号:">
              <el-input v-model="formInline.orderNo" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="审核状态:">
              <!-- <el-select v-model="formInline.auditStatus" placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option v-for='(v, k) in $config.auditStatus' :key='k' :label="v" :value="k" />
              </el-select> -->
              <el-select v-model="formInline.auditStatus" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="已审核" value="AUDITED"></el-option>
                <el-option label="未审核" value="APPLY"></el-option>
                <el-option label="已拒绝" value="REJECTED"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="订单类型:">
              <el-select v-model="formInline.orderType" placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option v-for='(v,k) in $config.orderType' :key='k' :label="v" :value="k" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="创建日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button class="search-ok" @click="exportExcel" v-if="$hasPermission('oms:admin:orderDiscount:export')" round>导出Excel </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%" fit>
          <!-- <el-table-column prop="serialNo" label="流水号" fixed="left" min-width="220px"></el-table-column> -->
          <el-table-column label="订单号" min-width="210px" fixed="left">
            <template v-slot="scope">
              <span class="color-blue" @click="goPath(scope.row)">{{ scope.row.order.orderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order.storeCode" label="平台号" min-width="100"></el-table-column>
          <el-table-column prop="order.storeName" label="平台名称" min-width="150"></el-table-column>
          <el-table-column prop="order.salesman" label="业务" min-width="130"></el-table-column>
          <el-table-column prop="dateCreated" label="创建日期" min-width="170"></el-table-column>
          <el-table-column prop="order.datePayment" label="支付日期" min-width="170"></el-table-column>
          <el-table-column prop="order.priceTotal" label="会员总价" min-width="80"></el-table-column>
          <el-table-column prop="discountAmount" label="申请支付价格" min-width="120"></el-table-column>
          <el-table-column label="审核状态" min-width="100px" fixed="right">
            <template v-slot="scope">
              <span class="color-blue" v-if="scope.row.auditStatus === 'APPLY' && $hasPermission('oms:admin:orderDiscount:audit')" @click="goPath(scope.row)">{{
                  $config.auditStatus[scope.row.auditStatus]
              }}</span>
              <span v-else>{{ $config.auditStatus[scope.row.auditStatus] || scope.row.auditStatus }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" v-permission="'oms:admin:orderDiscount:list'" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { orderDiscountPage, discountExport } from '@/api/oms'
import { storeQueryListByCode, getSalesmanByFullName } from '@/api/crm'
export default {
  name: 'balance-payment',
  components: {
    VPagination
  },
  inject: ['reload'],
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.formInline.dateStart = val[0] + ' 00:00:00'
          this.formInline.dateEnd = val[1] + ' 23:59:59'
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      storeListByCode: [],
      basicsInfo: {
        fullName: '',
        storeCode: ''
      },
      queryInfo: {
        // type: 3,
        total: 0,
        pageNum: 1, // 当前显示第几页
        pageSize: 20 // 每一页显示条数
      },
      formInline: {
        auditStatus: null,
        dateEnd: null,
        dateStart: null,
        orderNo: '',
        salesmanId: null,
        serialNo: '',
        storeId: null
      },
      tableData: [],
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      salemanList: []
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))

      this.value2[0] = this.formInline.dateStart.split(' ')[0]
      this.value2[1] = this.formInline.dateEnd.split(' ')[0]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('salemanList')
    }
    this.onSubmit()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      }
      orderDiscountPage({
        params: {
          page: this.queryInfo.pageNum - 1,
          size: this.queryInfo.pageSize,
          sort: 'dateCreated,desc'
        },
        data: Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value]))
      })
        .then((res) => {
          if (res.data.success) {
            this.tableData = res.data.data.content
            this.queryInfo.total = res.data.data.total
          }
        })
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      discountExport(this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '余额支付申请表' + this.value2[0] + '-' + this.value2[1] + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    goPath (val) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      this.$router.push({
        path: '/orderdetail',
        query: {
          orderNo: val.order.orderNo,
          orderDiscount: {
            discountAmountTotal: val.discountAmountTotal,
            discountAmount: val.discountAmount,
            auditStatus: val.auditStatus
          },
          way: 2
        }
      })
    },
    handleSelect (item) {
      this.formInline.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    selectFullName (item) {
      this.formInline.salesmanId = item.id
    },
    queryFullNameAsync (queryString, cb) {
      // 改成业务的模糊查询
      getSalesmanByFullName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.fullName
        })
        cb(res.data.data)
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
